import type { DateAgnosticTime } from "./date-agnostic-time";

const timePartToString = (part: number) => `0${part}`.slice(-2);
const hourToString = (hour: number) => timePartToString(hour);
const minuteToString = (minute: number) => timePartToString(minute);

type TimeToStringOptions = {
    ignoreMinutesIfZero?: boolean;
};

function dateAgnosticTimeToString(
    time: Date,
    options?: TimeToStringOptions
): string;
function dateAgnosticTimeToString(
    time: DateAgnosticTime,
    options?: TimeToStringOptions
): string;
function dateAgnosticTimeToString(
    time: Date | DateAgnosticTime,
    options?: TimeToStringOptions
): string {
    const ignoreMinutesIfZero = !!options?.ignoreMinutesIfZero;

    const to = (time: { hour: number; minute: number }): string =>
        ignoreMinutesIfZero && time.minute === 0
            ? hourToString(time.hour)
            : `${hourToString(time.hour)}:${minuteToString(time.minute)}`;

    if (time instanceof Date)
        return to({ hour: time.getHours(), minute: time.getMinutes() });

    return to(time);
}

export type { TimeToStringOptions };
export { hourToString, minuteToString, dateAgnosticTimeToString };
